// fr strings for messages/hub.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const hub: Dict = {
  "hub.views.count": "Plus de 10 milliards",
  "hub.views.on": "de vues sur",
  "hub.badge.covers": "Plus de 10 M de covers",
  "hub.badge.quality": "Qualité studio",
  "hub.badge.youtube": "Vu sur YouTube",
  "hub.trending": "Tendances",
  "hub.popular": "Voix populaires en ce moment",
  "hub.browseAll": "Tout voir",
  "hub.byCategory": "Explore les voix par catégorie",
  "hub.aiVoices": "Voix IA",
  "hub.howItWorks": "Comment ça marche",
  "hub.faq": "Questions fréquentes",
  "hub.keepExploring": "Continue d'explorer",
  "hub.moreWays": "D'autres façons de créer avec Jammable.",
  "hub.home": "Accueil",

  "widget.title": "Choisis une voix pour commencer",
  "widget.search": "Rechercher des voix",
  "widget.clear": "Effacer la recherche",
  "widget.matching": "Voix correspondant à « {q} »",
  "widget.popular": "Populaires en ce moment",
  "widget.noMatch": "Aucune voix ne correspond à cette recherche.",
  "widget.searchAny": "Recherche n'importe quelle voix ci-dessus.",
  "widget.coverWith": "Faire une cover avec {name}",
  "widget.start": "Commencer avec n'importe quelle voix",
  "widget.rights":
    "Ensuite, tu ajoutes ton audio. Importe uniquement des audios que tu as le droit d'utiliser.",

  "lang.viewThisPage": "Voir cette page en français",
  "lang.dismiss": "Fermer",
};

export default hub;
